export default __webpack_public_path__ + "static/media/a.f7cb6fb1.svg";